$(document).ready(function () {
  if ($(".in-index").length || $(".type-detail").length) {
    $(".products-block").each(function (index) {
      $(this).addClass("swiper-wrapper").wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper myproducts-swiper-" + index + "'></div></div>");
      $("<div class='myswiper-navi myswiper-navi-" + index + "'><div class='fake-product'></div><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div></div><div class='swiper-pagination swiper-pagination-" + index + "'></div>").appendTo($(this).parent(".myproducts-swiper").parent(".whole-wrap"));
      $($(this).find(".product")).addClass("swiper-slide");
      const productSwiper = new Swiper('.myproducts-swiper-' + index, {
        pagination: {
          el: '.swiper-pagination-' + index,
          clickable: true,
        },
        navigation: {
          nextEl: ".myswiper-navi-" + index + " .myswiper-next",
          prevEl: ".myswiper-navi-" + index + " .myswiper-prev",
        },
        slidesPerView: 'auto',
        spaceBetween: 10,
        breakpoints: {
          1440: {
            spaceBetween: 35,
          },

          768: {
            spaceBetween: 20,
          },
        },
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
          thresholdDelta: 10,
        },
      });
    });
  }
});